// The trends band's figures (founder pick E, 2026-09-29: "Students already
// build. It still stands out."). Every figure was re-read on 2026-09-29 from
// the page linked beside it; the record, with what each figure does NOT
// prove, is marketing/research/2026-09-29-builder-positioning-sources.md (tag
// in `tag`), and landingTrends.test.js pins each figure to that record.
//
// Rules the page follows with these:
//   - each figure keeps its own scope (a named competition, a named year,
//     "at Harvard");
//   - every figure counts STUDENTS or a student outcome. The USPTO count of
//     provisional applications (T4) was on the mock and is left out on
//     purpose: it counts every filer, not students, and the record warns
//     against implying otherwise (founder's pick, "with the patent tile
//     fixed");
//   - nothing here says a filing, paper or pitch gets anyone admitted or
//     hired, and the band says so plainly.
//
// The Harvard figures are data/landingEvidence.js's, the one pinned copy.

import { HARVARD_LEAD } from './landingEvidence';

export const TRENDS_READ_ON = 'Sep 29, 2026';

export const TREND = {
    // T1: students already build, in the open, in large numbers.
    appchallenge: {
        tag: 'T1',
        lead: '13,830',
        line: 'students took part in the Congressional App Challenge in 2025, an all-time record.',
        source: 'Congressional App Challenge, 2025 dashboard',
        url: 'https://www.congressionalappchallenge.us/state-of-the-app-challenge-2025-dashboard/',
    },
    // T2
    isef: {
        tag: 'T2',
        qualifier: 'More than',
        lead: '1,700',
        line: 'young scientists, engineers and inventors brought their own projects to Regeneron ISEF 2026, chosen from 365 fairs in more than 60 countries, regions and territories.',
        source: 'Society for Science, Regeneron ISEF',
        url: 'https://www.societyforscience.org/isef/',
    },
    // T3: in place of the mock's USPTO tile (see above).
    sts: {
        tag: 'T3',
        qualifier: 'More than',
        lead: '2,600',
        line: 'students applied to the Regeneron Science Talent Search in 2026 with research of their own.',
        source: 'Society for Science, Regeneron STS',
        url: 'https://www.societyforscience.org/regeneron-sts/',
    },
    // H2/H3: real work is rarer than good grades, at the most selective end.
    harvard: {
        tag: 'H2/H3',
        lead: HARVARD_LEAD.activities.value,
        line: `of Harvard applicants reach a top-two rating for activities. ${HARVARD_LEAD.academics.value} reach it for academics.`,
        source: HARVARD_LEAD.source,
        url: HARVARD_LEAD.url,
    },
};
